/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// material
import {
    Group,
    Control,
    Switch
} from '@insticator/insticator-ui'; // iui-material
import SectionCard from 'material/expandablesection/sectioncard/sectioncard';
import SectionGroup from 'material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from 'material/expandablesection/sectiongroupdescription/sectiongroupdescription'
// actions
import { updateAdvanceSettings } from 'state/actions/commentingState/configurationStatus';

// utils
// styles


const AdvanceSettings = (props) => {

    // redux state
    const group = useSelector(({ commentingState }) => commentingState.configStatus.general.advancedSettings.group);
    const isLoadCommentsButtonEnabled = useSelector(({ commentingState }) => commentingState.configStatus.general.advancedSettings.isLoadCommentsButtonEnabled);
    const allowDisqusAccountLink = useSelector(({ commentingState }) => commentingState.configStatus.general.advancedSettings.allowDisqusAccountLink);
    // action dispatch
    const dispatch = useDispatch();
    const updateAdvanceSettingsState = (prop, value) => dispatch(updateAdvanceSettings(prop, value));
    
    return (
        <SectionCard title='ADVANCED SETTINGS'>
            <SectionGroup>
                <SectionGroupDescription
                    title='Group'
                    description='Choose a group for this integration.'
                />
                <Group name={'controls advance'}>
                    <Control text={'Demo'}
                             value={'DEMO'}
                             selected={group === 'DEMO'}
                             handleSelect={value => updateAdvanceSettingsState('group', value)}
                             variant={'secondary'}
                             addCheckWhenSelected={true}
                    />
                    <Control text={'Customer'}
                             value={'CUSTOMER'}
                             selected={group === 'CUSTOMER'}
                             handleSelect={value => updateAdvanceSettingsState('group', value)}
                             variant={'secondary'}
                             addCheckWhenSelected={true}
                    />
                    <Control text={'Internal'}
                             value={'INTERNAL'}
                             selected={group === 'INTERNAL'}
                             handleSelect={value => updateAdvanceSettingsState('group', value)}
                             variant={'secondary'}
                             addCheckWhenSelected={true}
                    />
                    <Control text={'Test'}
                             value={'TEST'}
                             selected={group === 'TEST'}
                             handleSelect={value => updateAdvanceSettingsState('group', value)}
                             variant={'secondary'}
                             addCheckWhenSelected={true}
                    />
                </Group>
            </SectionGroup>

            <SectionGroup row>
                <SectionGroupDescription
                    title='Require authentication to view commenting unit'
                    description='Visitors will be required to sign up and/or sign in to get access to the commenting unit.'
                />
                <Switch
                    on={isLoadCommentsButtonEnabled}
                    handleClick={() => updateAdvanceSettingsState('isLoadCommentsButtonEnabled', !isLoadCommentsButtonEnabled)}
                    isStatic={true}
                    variant='secondary'
                />
            </SectionGroup>
            <SectionGroup row>
                <SectionGroupDescription 
                    title='Allow users to link Disqus account'
                    description='An additional step will be added to the Sign-up flow prompting users to link their Disqus account.'
                />
                <Switch
                    on={allowDisqusAccountLink}
                    isStatic={true}
                    handleClick={() => updateAdvanceSettingsState('allowDisqusAccountLink', !allowDisqusAccountLink)}
                    variant='secondary'
                />
            </SectionGroup>
        </SectionCard>
    )
};

export default AdvanceSettings
